var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388BF2",
    fillRule: "evenodd",
    d: "M20.61 11H21a1 1 0 0 1 0 2h-.39A8.67 8.67 0 0 1 13 20.61V21a1 1 0 0 1-2 0v-.39A8.67 8.67 0 0 1 3.39 13H3a1 1 0 0 1 0-2h.39A8.67 8.67 0 0 1 11 3.39V3a1 1 0 0 1 2 0v.39A8.67 8.67 0 0 1 20.61 11zm-2.018 0A6.671 6.671 0 0 0 13 5.408v.036a1 1 0 0 1-2 0v-.036A6.671 6.671 0 0 0 5.408 11h.036a1 1 0 0 1 0 2h-.036A6.671 6.671 0 0 0 11 18.592v-.036a1 1 0 1 1 2 0v.036A6.671 6.671 0 0 0 18.592 13h-.036a1 1 0 1 1 0-2h.036zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/change-icon.6dc03bfa1ff6443dbe46ae4938fbf5ba.svg";
export { ForwardRef as ReactComponent };